import PositionHelper from "./position.helper";
import NotificationHandler from "../NotificationHandler";
import { NotificationType } from "@/types/Notification";
var overlap_single = function (scene, p_0, p_1, callback, default_cb) {
    if (default_cb === void 0) { default_cb = true; }
    scene.physics.add.overlap(p_0.weapon.getBody(), p_1.character, function (a, b) {
        if (!p_0.getValue().game.is_alive)
            return;
        if (!p_1.getValue().game.is_alive)
            return;
        if (!p_0.weapon.getAnimationStatus())
            return;
        if (default_cb) {
            p_1.death();
            p_0.addKillStrike();
        }
        callback === null || callback === void 0 ? void 0 : callback(p_0, p_1);
    });
};
// enemy
var overlap_enemy = function (scene, enemy, arr) {
    var cb = function (p_0, p_1) {
        var _a = PositionHelper.run(), x = _a.x, y = _a.y;
        p_1.setPosition(x, y);
    };
    arr.forEach(function (e) {
        overlap_single(scene, enemy, e, cb);
        overlap_single(scene, e, enemy, cb);
    });
};
// player
var overlap_player = function (scene, player, enemy) {
    overlap_single(scene, player, enemy, function () {
        // reloc enemy
        var _a = PositionHelper.run(), x = _a.x, y = _a.y;
        enemy.setPosition(x, y);
        // exp
        NotificationHandler.getInstance().push({
            type: NotificationType.EXP,
            detail: {
                exp: 500,
            },
        });
        // strike
        NotificationHandler.getInstance().push({
            type: NotificationType.KILL_STRIKE,
            detail: {
                loser: enemy.getValue().username,
                strike: player.getValue().game.count_strike,
                count: player.getValue().game.count_kill,
            },
        });
    });
    overlap_single(scene, enemy, player, function () {
        player.NOTIFY_DEATH();
        enemy.addKillStrike();
    }, false);
};
// merge
var overlap = function (scene, player, enemy, enemies) {
    overlap_player(scene, player, enemy);
    overlap_enemy(scene, enemy, enemies);
};
var OverlapHelper = {
    overlap: overlap,
};
export default OverlapHelper;
